require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-come-party-with-us-on-cinco-de-mayo.json") })
        }
      }, "path---blog-come-party-with-us-on-cinco-de-mayo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-come-party-with-us-on-cinco-de-mayo!./.cache/json/blog-come-party-with-us-on-cinco-de-mayo.json
// module id = 783
// module chunks = 231608221292675